import React, { PropsWithChildren } from 'react';
import { layoutFooterWrapperStyle } from './layout-footer.styles.css';

export const LayoutFooter: React.FC<PropsWithChildren<unknown>> = ({
    children
}) => <div className={layoutFooterWrapperStyle}>{children}</div>;
